/**
 * 작성자 : 홍선영
 * 날짜 : 2023.05.10
 * 경로 : 일반관리-현장관리 페이지
 */

import { useState, useRef, useEffect } from 'react';
import { useLocation, useOutletContext, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';

import { IModal, INumbers, ITabObject } from 'customTypes';
import { userState, pageInfoState } from '../../atoms';
// import { useDetectScrolledToBottom } from '../../utils/useDetectScrolledToBottom';
import { checkUserInputRequiredValue } from '../../utils/checkUserInputRequiredValue';
import { emailRegex, passwordRegex } from '../../utils/checkRegex';
import { SearchOptions } from '../../assets/styles/SearchOptions';
import Input from '../../components/Input';
import Tab from '../../components/Tab';
import ViewTable from '../../components/Table/ViewTable';
import SiteInfo from './common4/siteInfo';
import SiteManager from './common4/siteManager';
import { COMCD_LOCK_YN, COMCD_USE_YN, INIT_LOCK_YN_A, INIT_LOCK_YN_N, INIT_USE_YN_A, INIT_USE_YN_Y, SELECT_SNAME_OR_ADMINUSERNAME } from '../../_constants';
import { BtnGhost } from '../../components/Button';
import { trimObject } from '../../utils/trimObject';
import { checkPhonNumEmpty } from '../../utils/checkPhonNumEmpty';
import UserInfoInputFormSiteAdmin from '../../components/Form/UserInfoInputFormSiteAdmin';
import { logPost } from '../../services/log';
import { useTranslation } from 'react-i18next';
import BackButton from '../../components/BackButton';
import Portal from '../../components/Portal';
import DeleteModal from '../../components/Modal/DeleteModal2';
import { registerSiteInfo } from '../../services/register';
import SelectBox from '../../components/SelectBox';
import { apiDelete, apiGet, apiPatch, apiPost } from '../../services/_common';
import { useFetchCommonCodeList } from '../../services/useSetCodeListInSelectBoxForm';
import { ynFilter } from '../../utils/ynFilter';

interface IMaster {
  width?: string;
  flexDirection?: string;
}

const Root = styled.div<IMaster>`
  &.hideRoot {
    visibility: hidden;
    position: absolute !important;
  }
  .inputForm-body {
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  > .inputFormsWrapper {
    height: 3.5rem !important;
    flex-shrink: 0;
    display: flex;
    flex-direction: row !important;
    align-items: center;
    padding: 0 0.5rem;
    border-bottom: 1px solid var(--outline);
    @media (min-width: 1025px) {
      padding: 0 1rem;
    }
  }
`;

interface IProps {
  typeName: string;
  gCd: 'SM';
}

const Mcommon4 = ({ typeName, gCd }: IProps) => {
  const { t } = useTranslation();
  const size = useOutletContext<any>();
  const { pathname } = useLocation();
  const userInfo = useRecoilValue(userState);
  const node = useRef<any>(null);
  const userInfoInputFormRef = useRef<any>(null); // 인풋 폼 ref (테이블 로우를 클릭했을 때 바로 inputForm 으로 스크롤 이동시키기 위한 ref)
  const [openModal, setOpenModal] = useState<IModal>({ status: false, type: '', title: '' });
  const initialSearchOption = size.innerSize.W > 1024 ? { type: 'nameType', nameType: 'sName', cdName: t('현장명') } : { type: 'nameType', nameType: 'userName', cdName: t('관리자명') };
  const [searchOption, setSearchOption] = useState(initialSearchOption);
  const [searchName, setSearchName] = useState({ sName: '', userName: '' });
  const [searchOptionUseYn, setSearchOptionUseYn] = useState(INIT_USE_YN_A);
  const [searchOptionLockYn, setSearchOptionLockYn] = useState(INIT_LOCK_YN_A);
  const [isNewAdd, setIsNewAdd] = useState(true); // 신규등록 여부
  const [isSettingPassword, setIsSettingPassword] = useState(false); // 패스워드 변경여부
  const [rowState, setRowState] = useState({
    userId: '',
    isDuplicateChecked: false,
    userName: '',
    hpNum: '',
    telNum: '',
    eMail: '',
    ipInfo: '',
    displayPassword: '',
    newPassword: '',
    newPasswordConfirm: '',
    bigo: '',
    delYn: '',
    eDate: '',
    editor: '',
    lockYn: 'N',
    useYn: 'Y',
    userPwd: '',
    wDate: '',
    writer: '',
    loginerrorCount: '',
    gCd, // 고정값,
    hCd: '',
    sCd: '',
    sName: '',
    hName: '',
  }); // 서버에서 받아 온 raw data 어레이 중 1줄의 데이터 state
  const [viewData, setViewData] = useState([{}]); // 서버에서 받아 온 raw data 중 viewTable에 뿌려줄 데이터만 담는 state
  const [columnCount, setColumnCount] = useState(0);
  // const { isBottom } = useDetectScrolledToBottom(userInfoInputFormRef); // 스크롤이 해당노드의 하단에 근접했는지 여부 (플로팅버튼 띄우기 위함)
  const [userList, setUserList] = useState<any>([]);
  const [orgUserList, setOrgUserList] = useState<any>([]); // 필터링되지않은 유저리스트
  const [telNumState, setTelNumState] = useState<INumbers>({ num1: '', num2: '', num3: '' });
  const [hpNumState, setHpNumState] = useState<INumbers>({ num1: '010', num2: '', num3: '' });
  const [ipInfoState, setIpInfoState] = useState<INumbers>({ num1: '', num2: '', num3: '', num4: '' });
  const [hCd, setHCd] = useState<any>({ type: 'hCd', hCd: '', cdName: '' });
  const [sCd, setSCd] = useState<any>({ type: 'sCd', sCd: '', cdName: '' });
  const [lockYn, setLockYn] = useState(INIT_LOCK_YN_N); // 잠금유무 공통코드
  const [useYn, setUseYn] = useState(INIT_USE_YN_Y); // 사용유무 공통코드
  const [hList, setHlist] = useState([]);
  const [sList, setSlist] = useState([]);
  const [isSaveClicked, setIsSaveClicked] = useState(false); // 저장버튼 클릭 여부에 따라 필수입력값 보더색상 처리하기 위한 state 값
  const [viewMainPage, setViewMainPage] = useState(true);
  const { data: useYnComCdListWithAll } = useFetchCommonCodeList(COMCD_USE_YN, true); // 사용여부 공통코드 목록 (검색조건에서 사용, 전체포함)
  const { data: lockYnComCdListWithAll } = useFetchCommonCodeList(COMCD_LOCK_YN, true); // 잠금여부 공통코드 목록 (검색조건에서 사용, 전체포함)
  const { data: useYnComCdList } = useFetchCommonCodeList(COMCD_USE_YN, false); // 사용유무 공통코드 목록 (사용자 정보에서 사용)
  const { data: lockYnComCdList } = useFetchCommonCodeList(COMCD_LOCK_YN, false); // 잠금유무 공통코드 목록 (사용자 정보에서 사용)

  useEffect(() => {
    getUserListAPI().then((res: any) => {
      if (res.status === 200) {
        getHeadInfoAPI();
        logPost({
          hCd: userInfo.hCd,
          sCd: userInfo.sCd,
          userId: userInfo.userId,
          menu: '현장 관리 > 현장 관리자',
          action: '조회',
          etc: ``,
        });
      }
    });
  }, []);

  // 유저가 hCd를 선택했을 때 hCd setState 후 sCdList 조회 API 호출
  useEffect(() => {
    if (hCd.hCd !== '') getSCdAPI(hCd.hCd);
  }, [hCd.hCd]);

  // sCd API 호출해서 sCd목록 setState
  const getSCdAPI = async (hCdParam: string) => {
    const res = await registerSiteInfo(hCdParam);
    const { data, statusCode } = res.data;
    if (statusCode === 200) {
      const newArray = data.map((el: any) => ({ type: 'sCd', sCd: el.sCd, cdName: el.sName }));
      setSlist(newArray);
    }
  };

  // 본사 리스트 조회 API
  const getHeadInfoAPI = async () => {
    const res = await apiGet({ path: '/menu/headInfo' });
    const { data, statusCode } = res.data;
    if (statusCode === 200) {
      const newArray = data.map((el: any) => ({ type: 'hCd', hCd: el.hCd, cdName: el.hName }));
      setHlist(newArray);
    }
    return res;
  };

  // 로우데이터에서 뷰테이블에 보여줄 데이터만 뽑아서 배열에 담아 리턴
  const setDataIntoViewTable = (properties: any) => {
    setColumnCount(properties.length);
    const viewDataArray: any = [];
    const allKeys = Object.keys(userList[0]);
    userList?.map((el: any, i: number) => {
      const result = allKeys.reduce((next, key: any) => {
        if (properties.includes(key)) {
          return { ...next, [key]: userList[i][key] };
        }
        return next;
      }, {});
      return viewDataArray.push(result);
    });
    setViewData(viewDataArray);
  };

  useEffect(() => {
    // 도메인에 따라서 뷰테이블에 전달해야하는 키값만 viewTableProperties 배열안에 작성하면 됨.
    if (userList && userList.length > 0) {
      const viewTableProperties = ['sCd', 'hName', 'sName', 'userId', 'userName', 'gName', 'lockYn', 'useYn'];
      setDataIntoViewTable(viewTableProperties);
    }
  }, [userList, pathname]);

  const applyFilter = (array: any[]) => {
    // 필터링 기준
    const filterOptions = {
      nameType: searchOption.nameType,
      userName: searchName.userName,
      sName: searchName.sName,
      useYn: searchOptionUseYn[COMCD_USE_YN],
      lockYn: searchOptionLockYn[COMCD_LOCK_YN],
    };

    // 필터링된 어레이 리턴, 대소문자구분X
    const filteredArray = array.filter((item: any) => {
      if (filterOptions.nameType === 'sName') {
        return item[searchOption.nameType]?.toLowerCase()?.includes(filterOptions.sName?.toLowerCase());
      }
      return item[searchOption.nameType]?.toLowerCase()?.includes(filterOptions.userName?.toLowerCase());
    });

    if ((filterOptions.nameType === 'sName' && filterOptions.sName === '') || (filterOptions.nameType === 'userName' && filterOptions.userName === '')) {
      const useYnFilter = ynFilter(array, 'useYn', searchOptionUseYn[COMCD_USE_YN]);
      const result = ynFilter(useYnFilter, 'lockYn', searchOptionLockYn[COMCD_LOCK_YN]);
      if (result.length > 0) {
        setUserList(result);
      } else {
        setUserList([]);
      }
    } else {
      const useYnFilter = ynFilter(filteredArray, 'useYn', searchOptionUseYn[COMCD_USE_YN]);
      const result = ynFilter(useYnFilter, 'lockYn', searchOptionLockYn[COMCD_LOCK_YN]);
      if (result.length > 0) {
        setUserList(result);
      } else {
        setUserList([]);
      }
    }
  };

  useEffect(() => {
    applyFilter(orgUserList);
  }, [searchOption.nameType, searchName.sName, searchName.userName, searchOptionLockYn[COMCD_LOCK_YN], searchOptionUseYn[COMCD_USE_YN]]);

  // 신규등록 API
  const insertNewUserAPI = async (resultData: any) => {
    const trimData = trimObject(resultData);
    const req = {
      userId: trimData.userId,
      userName: trimData.userName,
      userPwd: trimData.newPassword,
      gCd: trimData.gCd,
      hCd: trimData.hCd,
      sCd: trimData.sCd,
      sjCd: trimData.sjCd,
      hpNum: trimData.hpNum,
      telNum: trimData.telNum,
      eMail: trimData.eMail,
      ipInfo: trimData.ipInfo,
      pwdChangeDate: trimData.pwdChangeDate,
      useYn: trimData.useYn,
      lockYn: trimData.lockYn,
      bigo: trimData.bigo,
      approvalYn: 'Y',
      pwdCheckyn: 'N',
      loginerrorCount: 0,
      writer: userInfo.userId,
      editor: userInfo.userId,
    };
    const res = await apiPost({ path: '/user/site', contentType: 'application/json', req });
    const { statusCode, message, data } = res.data;
    if (statusCode === 200) {
      toast.success(t(message));
      const { userPwd, wDate, writer, eDate, editor, gName } = data[0];
      setRowState((prev) => ({ ...prev, displayPassword: rowState.newPassword, writer, wDate, editor, eDate, gName }));
      applyFilter(data[1].userList);
      setOrgUserList(data[1].userList);
      setIsNewAdd(false);
      await logPost({
        hCd: userInfo.hCd,
        sCd: userInfo.sCd,
        userId: userInfo.userId,
        menu: '마스터일반관리-현장관리',
        action: '현장 관리자 신규등록',
        etc: `본사명 : ${resultData.hName} / 현장명 : ${resultData.sName} / 관리자아이디 : ${resultData.userId} / 관리자명 : ${resultData.userName}`,
      });
    } else {
      // toast.error(t(ERROR));
    }
  };

  // 수정 API
  const updateUserAPI = async (resultData: any) => {
    const trimData = trimObject(resultData);
    const req = {
      userId: trimData.userId,
      userName: trimData.userName,
      userPwd: trimData.userPwd,
      gCd: trimData.gCd,
      hCd: trimData.hCd,
      sCd: trimData.sCd,
      sjCd: trimData.sjCd,
      hpNum: trimData.hpNum,
      telNum: trimData.telNum,
      eMail: trimData.eMail,
      ipInfo: trimData.ipInfo,
      useYn: trimData.useYn,
      lockYn: trimData.lockYn,
      bigo: trimData.bigo,
      approvalYn: 'Y',
      pwdCheckyn: 'N',
      loginerrorCount: 0,
      editor: userInfo.userId,
    };
    const res = await apiPatch({ path: '/user/site', contentType: 'application/json', req });
    const { statusCode, message, data } = res.data;
    if (statusCode === 200) {
      const { userPwd } = data[0];
      toast.success(t(message));
      setRowState({ ...data[0], displayPassword: userPwd });
      applyFilter(data[1].userList);
      setOrgUserList(data[1].userList);

      await logPost({
        hCd: userInfo.hCd,
        sCd: userInfo.sCd,
        userId: userInfo.userId,
        menu: '마스터일반관리-현장관리',
        action: '현장 관리자 수정',
        etc: `본사명 : ${resultData.hName} / 현장명 : ${resultData.sName} / 관리자아이디 : ${resultData.userId} / 관리자명 : ${resultData.userName}`,
      });
    } else {
      toast.error(t(message));
    }
  };

  // 조회 API
  const getUserListAPI = async () => {
    const res = await apiGet({ path: '/user/site' });
    const { status, data } = res;
    if (status === 200) {
      // 삭제되지 않은 유저만 필터링해서 setState
      const activeUsers = data.data.userList.filter((el: any) => el.delYn === 'N');
      setUserList(activeUsers);
      setOrgUserList(activeUsers);
    }
    return res;
  };

  const onClickDelete = async () => {
    setOpenModal((prev) => ({ ...prev, status: true, type: 'delete', api: deleteAPI }));
  };

  // 삭제 API
  const deleteAPI = async () => {
    const { userId, editor } = rowState;
    const req = { userId, editor };
    const res = await apiDelete({ path: '/user/site', req });
    const { message, statusCode } = res.data;
    if (statusCode === 200) {
      toast.success(t(message));
      // 삭제된로우 리스트에서 제거
      const newArray = userList.filter((el: any) => el.userId !== rowState.userId);
      setUserList(newArray);
      initiateState();
      setIsNewAdd(true);
      await logPost({
        hCd: userInfo.hCd,
        sCd: userInfo.sCd,
        userId: userInfo.userId,
        menu: '현장관리 > 현장정보',
        action: '현장 관리자 삭제',
        etc: `본사명 : ${rowState.hName} / 현장명 : ${rowState.sName} / 관리자아이디 : ${rowState.userId} / 관리자명 : ${rowState.userName}`,
      });
    } else {
      // toast.error(t(ERROR));
    }
  };

  // 저장버튼 클릭해서 save API 호출하여 데이터전송
  const onClickSave = async () => {
    setIsSaveClicked(true);
    const mergedHpNumber = `${hpNumState.num1}-${hpNumState.num2}-${hpNumState.num3}`;
    const mergedTelNumber = telNumState.num1 === '' && telNumState.num2 === '' && telNumState.num3 === '' ? '' : `${telNumState.num1}-${telNumState.num2}-${telNumState.num3}`;
    const mergedIpNumber =
      ipInfoState.num1 === '' && ipInfoState.num2 === '' && ipInfoState.num3 === '' && ipInfoState.num4 === '' ? '' : `${ipInfoState.num1}.${ipInfoState.num2}.${ipInfoState.num3}.${ipInfoState.num4}`;
    const resultData = { ...rowState, hpNum: mergedHpNumber, telNum: mergedTelNumber, ipInfo: mergedIpNumber };

    const { newPassword, newPasswordConfirm, eMail } = resultData;
    const { isUserInputRequiredValuePass, userInputRequiredValueMsg } = checkUserInputRequiredValue(resultData);
    const { isEmpty, emptyAlertMessage } = checkPhonNumEmpty(hpNumState);
    const { isEmailRegexPass, emailRegexAlertMsg } = emailRegex(eMail);
    if (hCd.hCd === '') return toast.warning(t('본사명을 선택하세요'));
    if (sCd.sCd === '') return toast.warning(t('현장명을 선택하세요'));
    if (isNewAdd && !isUserInputRequiredValuePass) return toast.warning(t(userInputRequiredValueMsg));
    if (isSettingPassword) {
      return toast.warning(t('비밀번호 변경버튼을 클릭하여 변경을 완료하세요'));
    }
    if (isNewAdd || (!isNewAdd && isSettingPassword)) {
      const { isPasswordRegexPass, passwordRegexAlertMsg } = passwordRegex(newPassword, newPasswordConfirm);
      if (!isPasswordRegexPass) return toast.warning(t(passwordRegexAlertMsg));
    }
    if (isEmpty) return toast.warning(t(emptyAlertMessage));
    if (!isEmailRegexPass) return toast.warning(t(emailRegexAlertMsg));
    if (isNewAdd) return insertNewUserAPI(resultData);

    return updateUserAPI(resultData);
  };

  const resetSelectAllOptions = () => {
    setHCd({ type: 'hCd', hCd: '', cdName: '' });
    setSCd({ type: 'sCd', sCd: '', cdName: '' });
  };

  // 신규등록 버튼 클릭해서 새 입력창(iputForm) 노출
  const onClickNewRegistration = () => {
    initiateState();
    setIsNewAdd(true);
    resetSelectAllOptions();
    setLockYn(INIT_LOCK_YN_N);
    setUseYn(INIT_USE_YN_Y);
    if (size.innerSize.W <= 1024) {
      setViewMainPage(false);
    }
  };

  // 스테이트 객체의 밸류를 ''로 초기화(고정값인 gCd는 제외)
  const initiateState = () => {
    const keys = Object.keys(rowState);
    const filteredKeys = keys.filter((keyEl: string) => keyEl !== 'gCd');
    filteredKeys.map((el) => {
      return setRowState((prev: any) => ({ ...prev, [el]: '', isDuplicateChecked: false, useYn: 'Y', lockYn: 'N' }));
    });
    setIsSaveClicked(false);
    setHpNumState({ num1: '010', num2: '', num3: '' });
    setTelNumState({ num1: '', num2: '', num3: '' });
    setIpInfoState({ num1: '', num2: '', num3: '', num4: '' });
  };

  const onClickInitiateSearchOption = () => {
    setSearchOptionUseYn(INIT_USE_YN_A);
    setSearchOptionLockYn(INIT_LOCK_YN_A);
    setSearchOption({ type: 'nameType', nameType: 'sName', cdName: t('현장명') });
    setLockYn(INIT_LOCK_YN_N);
    setUseYn(INIT_USE_YN_Y);
    setSearchName({ sName: '', userName: '' });

    if (size.innerSize.W > 1024) {
      onClickNewRegistration(); // 우측 인풋창도 초기화
    }
  };

  const backToMain = () => {
    setViewMainPage(true);
  };

  return (
    <div className={`content-container ${size.innerSize.W > 1024 ? 'twoColumn column-55 max800' : 'oneColumn'}`}>
      <Root className={size.innerSize.W > 1024 || viewMainPage ? 'showRoot' : 'hideRoot'}>
        <SearchOptions>
          {size.innerSize.W > 1024 ? (
            <>
              <div className='inputsWrapper'>
                <div className='inputForm-row'>
                  <div className='inputForm-col withLabelComCf'>
                    <label htmlFor='useYn'>{t('사용유무')}</label>
                    <SelectBox
                      options={useYnComCdListWithAll}
                      defaultOption={t('전체')}
                      state={searchOptionUseYn}
                      setState={setSearchOptionUseYn}
                      stateKey={COMCD_USE_YN}
                      filterbar='filter-1-left'
                      initiateKey={searchOptionUseYn[COMCD_USE_YN]}
                    />
                  </div>
                </div>
                <div className='inputForm-row'>
                  <div className='inputForm-col withLabelComCf'>
                    <label htmlFor='useYn'>{t('잠금유무')}</label>
                    <SelectBox
                      options={lockYnComCdListWithAll}
                      defaultOption={t('전체')}
                      state={searchOptionLockYn}
                      setState={setSearchOptionLockYn}
                      stateKey={COMCD_LOCK_YN}
                      filterbar='filter-1-left'
                      initiateKey={searchOptionLockYn[COMCD_LOCK_YN]}
                    />
                  </div>
                </div>
                <div className='inputForm-row'>
                  <div className='inputForm-col'>
                    {/* <label htmlFor='useYn'>검색조건</label> */}
                    <SelectBox
                      options={SELECT_SNAME_OR_ADMINUSERNAME}
                      defaultOption={searchOption.nameType === 'sName' ? t('현장명') : t('관리자명')}
                      state={searchOption}
                      setState={setSearchOption}
                      stateKey='nameType'
                      initiateKey={searchOption.nameType}
                      filterbar='filter-1-center'
                    />
                  </div>
                </div>
                <div className='inputForm-row'>
                  <div className='inputForm-col'>
                    <Input
                      label=''
                      placeholder={searchOption.nameType === 'sName' ? t('현장명') : t('관리자명')}
                      type='text'
                      id={searchOption.nameType === 'sName' ? 'sName' : 'userName'}
                      name={searchOption.nameType === 'sName' ? 'sName' : 'userName'}
                      state={searchName}
                      setState={setSearchName}
                    />
                  </div>
                </div>
              </div>
              <div className='inputsWrapper'>
                <div className='secondSearchOption'>
                  <div className='flex-basic textBtnGroup'>
                    <BtnGhost onClick={onClickInitiateSearchOption}>{t('초기화')}</BtnGhost>
                  </div>
                  <div className='flex-basic iconBtnGroup'>
                    <BtnGhost onClick={onClickNewRegistration}>
                      <span className='material-symbols-rounded'>add</span>
                      {t('등록')}
                    </BtnGhost>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className='filter-wrapper'>
              <div className='inputsWrapper'>
                <div className='inputForm-row' style={{ width: '100%' }}>
                  <div className='inputForm-col'>
                    <Input label='' placeholder={t('관리자명')} type='search' id='userName' name='userName' state={searchName} setState={setSearchName} ico='search' />
                  </div>
                </div>
              </div>
              <div className='inputsWrapper'>
                <div className='flex-basic iconBtnGroup'>
                  <BtnGhost onClick={onClickNewRegistration}>
                    <span className='material-symbols-rounded'>add</span>
                    {t('등록')}
                  </BtnGhost>
                </div>
              </div>
            </div>
          )}
        </SearchOptions>
        <div className='searchContent inputForm-body' ref={node}>
          <ViewTable
            rawData={userList}
            state={viewData}
            setRowState={setRowState}
            setIsNewAdd={setIsNewAdd}
            setIsSettingPassword={setIsSettingPassword}
            userInfoInputFormRef={userInfoInputFormRef}
            typeName={typeName}
            setHCd={setHCd}
            setSCd={setSCd}
            setLockYn={setLockYn}
            setUseYn={setUseYn}
            setTelNumState={setTelNumState}
            setHpNumState={setHpNumState}
            setIpInfoState={setIpInfoState}
            setViewMainPage={() => setViewMainPage(false)}
          />
        </div>
      </Root>
      <Root className={size.innerSize.W > 1024 || !viewMainPage ? 'showRoot' : 'hideRoot'}>
        <div className='inputFormsWrapper flexRowEm'>
          {size.innerSize.W <= 1024 && <BackButton func={() => backToMain()} />}
          <div className='formTitle'>{isNewAdd ? t('새로운 현장관리자') : t('현장관리자 상세')}</div>
        </div>
        <UserInfoInputFormSiteAdmin
          state={rowState}
          setState={setRowState}
          isNewAdd={isNewAdd}
          userInfoInputFormRef={userInfoInputFormRef}
          isSettingPassword={isSettingPassword}
          setIsSettingPassword={setIsSettingPassword}
          onClickNewAdd={onClickNewRegistration}
          onClickSave={onClickSave}
          onClickDelete={onClickDelete}
          typeName={typeName}
          telNumState={telNumState}
          setTelNumState={setTelNumState}
          hpNumState={hpNumState}
          setHpNumState={setHpNumState}
          ipInfoState={ipInfoState}
          setIpInfoState={setIpInfoState}
          hCd={hCd}
          setHCd={setHCd}
          sCd={sCd}
          setSCd={setSCd}
          lockYn={lockYn}
          setLockYn={setLockYn}
          useYn={useYn}
          setUseYn={setUseYn}
          hList={hList}
          sList={sList}
          lockYnComCdList={lockYnComCdList}
          useYnComCdList={useYnComCdList}
          isSaveClicked={isSaveClicked}
        />
      </Root>
      <Portal openModal={openModal?.status}>{openModal && openModal.type === 'delete' && <DeleteModal openModal={openModal} setOpenModal={setOpenModal} />}</Portal>
    </div>
  );
};

const Mcommon5 = () => {
  const { t } = useTranslation();
  const size = useOutletContext<any>();
  const userInfo = useRecoilValue(userState);
  const tabInfo = useRecoilValue(pageInfoState);
  const [currentTabMrCd, setCurrentTabMrCd] = useState(tabInfo.defaultMrCd);
  const [searchParams] = useSearchParams();
  const tabCd = searchParams.get('tabCd');

  // URL의 tabCd 파라미터 변경 감지하여 탭 업데이트
  useEffect(() => {
    if (tabCd && tabCd !== currentTabMrCd) {
      setCurrentTabMrCd(tabCd);
    }
  }, [tabCd]);

  const onClickTab = (mrCd: string) => {
    setCurrentTabMrCd(mrCd);
  };

  const renderPage = () => {
    const activeTab = tabInfo.tabList?.find((el: ITabObject) => el.mrCd === currentTabMrCd);
    if (activeTab !== undefined) {
      const { mrCd } = activeTab;
      switch (mrCd) {
        case '001':
          return <SiteInfo type='m' />;
        case '002':
          return <SiteManager content={<Mcommon4 typeName={t('현장 관리자')} gCd='SM' />} />;
      }
    }
    return undefined;
  };

  return (
    <div className='contents'>
      <Tab tabList={tabInfo.tabList} currentTabMrCd={currentTabMrCd} setCurrentTabMrCd={setCurrentTabMrCd} onClickTab={onClickTab} size={size} />
      {renderPage()}
    </div>
  );
};

export default Mcommon5;
